//
//
//
//
//
//

export default {
  props: {
    loadingData: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}




// WEBPACK FOOTER //
// ./src/pages/build922/views/components/loading/index.vue